import { useRef } from 'react';
import '../Accounting/Accounting.css';
import { useReactToPrint } from 'react-to-print';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { QRCodeCanvas } from 'qrcode.react';


const formatNumber = (number, locale) => {
  // Ensure the number is a properly parsed float
  const parsedNumber = parseFloat(number);
  if (isNaN(parsedNumber)) {
    return '0.00';
  }
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(parsedNumber);
};

const formatDate = (dateString, locale) => {
  const date = new Date(dateString);
  return moment(date).format('DD MMM YYYY');
};

// Payment method transformation function
const transformPaymentMethod = (paymentMethod) => {
  const paymentMethods = {
    'bank_transfer': 'Bank Transfer',
    'credit_card': 'Credit Card',
    'cash': 'Cash',
    'debit_card': 'Debit Card',
    'online_payment': 'Online Payment',
    'cheque': 'Cheque',
    'mobile_payment': 'Mobile Payment'
  };
  
  return paymentMethods[paymentMethod] || paymentMethod || 'N/A';
};

// Generate QR code data from receipt number
const generateQRCodeData = (receiptNo) => {
  if (!receiptNo) return 'RECEIPT-000000';
  return receiptNo;
};


const StudentReceiptModal = ({ visible, onClose, paymentData }) => {
  const { t, i18n } = useTranslation();
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

    const branchInfo = {
    1: {
      name: "Keaes Academics (Ekamai)",
      address: [
        "982/22 Gateway Ekamai, 4th Fl. Sukhumvit Rd,",
        "Phra Khanong, Khlong Toei, Bangkok 10110"
      ],
      taxId: "0000000000000",
      tel: "02-108-2922",
      email: "contact@keaes.com"
    },
    2: {
      name: "Keaes Academics (Ramkhamhaeng)",
      address: [
        "61 Marketplace, 3rd Fl., Ramkhamhaeng Rd,",
        "Saphan Sung, Bangkok 10240"
      ],
      taxId: "0000000000000",
      tel: "02-729-5826",
      email: "contact@keaes.com"
    }
  };


const branch = branchInfo[paymentData?.branch_id] || null;

  const parseInventoryItems = (input) => {
    if (!input) return [];

    if (Array.isArray(input)) {
      return input.map(item => {
        try {
          return typeof item === 'string' ? JSON.parse(item) : item;
        } catch (e) {
          console.error('Error parsing inventory item:', e);
          return {};
        }
      });
    }

    // Fallback for raw stringified JSON array
    try {
      const parsed = JSON.parse(input);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error('Error parsing inventory JSON array:', e);
      return [];
    }
  };

  const getClasses = () => {
    if (!paymentData?.classes) return [];
    
    // Handle if classes is already an array
    if (Array.isArray(paymentData.classes)) {
      return paymentData.classes;
    }
    
    // Handle if classes is a JSON string
    try {
      return JSON.parse(paymentData.classes);
    } catch (error) {
      console.error('Error parsing classes:', error);
      return [];
    }
  };

  if (!visible || !paymentData) return null;

  const classes = getClasses();
  const receiptNo = paymentData?.receipt_no;

  // Calculate values
  const classesTotal = classes.reduce((sum, cls) => sum + parseFloat(cls.price || 0), 0);
  const totalBeforeDiscount = classesTotal;
  const discountAmount = parseFloat(paymentData?.discount) || 0;
  const totalAfterDiscount = totalBeforeDiscount - discountAmount;
  const vatAmount = parseFloat(paymentData?.vat) || 0;
  const grandTotal = parseFloat(paymentData?.final_price) || (totalAfterDiscount + vatAmount);
  const payAmount = parseFloat(paymentData?.pay_amount) || 0;
  const remainingBalance = parseFloat(paymentData?.remaining_balance) || 0;

  // Get course codes for display
  const courseCodes = classes.map(cls => cls.class_code).join(', ') || 'N/A';
  const totalHours = classes.reduce((sum, cls) => sum + parseFloat(cls.total_hours || 0), 0);

  // Generate QR code data
  const qrCodeData = generateQRCodeData(receiptNo);

  return (
    <div className="invoice-modal-overlay" style={{ 
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div className="invoice-modal" ref={componentRef} style={{ 
        backgroundColor: 'white',
        padding: '16px',
        width: '210mm',
        maxHeight: '90vh',
        overflowY: 'auto',
        position: 'relative',
      }}>
        {/* Refund watermark if applicable */}
        {paymentData?.is_refunded && (
          <div className="refund-watermark" style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%) rotate(-45deg)',
            fontSize: '72px',
            color: 'rgba(255, 0, 0, 0.15)',
            fontWeight: 'bold',
            zIndex: 0,
            pointerEvents: 'none'
          }}>
            {t('refund')}
          </div>
        )}
        
        <span className="modal-close-button" onClick={onClose} style={{
          position: 'absolute',
          top: '8px',
          right: '12px',
          fontSize: '20px',
          cursor: 'pointer',
          zIndex: 1,
          color: '#333',
          fontWeight: 'bold'
        }}>&times;</span>
        
        {/* Header section with logo and company info - Compact */}
        <div className="modal-header" style={{ 
          display: 'flex', 
          marginBottom: '12px',
          alignItems: 'flex-start'
        }}>
          {/* Left side - Logo */}
          <div className="company-logo" style={{ 
            width: '70px', 
            height: '70px',
            marginRight: '16px'
          }}>
            <img src="/images/keaes150.png" alt="KEAES" style={{ 
              width: '120%',
              height: 'auto'
            }} />
          </div>
          
          {/* Middle - Company info */}
         {/* Middle - Company info */}
<div style={{ flex: 1, paddingTop: '2px' }}>
  <h3 style={{ 
    fontSize: '14px', 
    fontWeight: 'bold', 
    marginBottom: '4px',
    marginTop: 0,
    color: '#333',
    textAlign: 'left',
    marginLeft: '24px'
  }}>
    {branch?.name || "Keaes Academics"}
  </h3>

  {branch?.address?.map((line, idx) => (
    <p key={idx} style={{ 
      fontSize: '10px', 
      margin: '1px 0',
      lineHeight: '1.2',
      color: '#4a4a4a',
      textAlign: 'left',
      marginLeft: '24px'
    }}>
      {line}
    </p>
  ))}
  <p style={{ fontSize: '10px', margin: '1px 0', lineHeight: '1.2', color: '#4a4a4a', textAlign: 'left', marginLeft: '24px' }}>
    Tel: {branch?.tel || 'N/A'}
  </p>
  <p style={{ fontSize: '10px', margin: '1px 0', lineHeight: '1.2', color: '#4a4a4a', textAlign: 'left', marginLeft: '24px' }}>
    Email: {branch?.email || 'N/A'}
  </p>
</div>

          
          {/* Right side - Receipt box */}
          <div style={{ 
            background: 'rgba(200, 200, 200, 0.3)', 
            padding: '12px', 
            color: '#333',
            borderRadius: '6px',
            width: '180px',
            textAlign: 'center',
            marginLeft: 'auto',
            maxWidth: 180
          }}>
            <h2 style={{ 
              color: '#333', 
              fontSize: '16px', 
              margin: '0 0 4px 0',
              fontWeight: 'bold',
              textAlign: 'center'
            }}>
              {t('receipt').toUpperCase()}
            </h2>
            <div className="invoice-details" style={{ marginBottom: 4 }}>
              <div className="detail-row" style={{ marginBottom: 2 }}>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  fontSize: '10px', 
                  margin: '2px 0' 
                }}>
                  <span style={{ fontWeight: 'bold', color: '#333' }}>{t('No.')}:</span>
                  <span style={{ color: '#333', marginLeft: 6 }}>{receiptNo}</span>
                </div>
              </div>
              <div className="detail-row" style={{ marginBottom: 2 }}>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  fontSize: '10px', 
                  margin: '2px 0' 
                }}>
                  <span style={{ fontWeight: 'bold', color: '#333' }}>{t('date')}:</span>
                  <span style={{ color: '#333', marginLeft: 6 }}>{formatDate(paymentData?.last_payment_date, i18n.language)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Customer Information - Compact */}
        <div className="customer-info" style={{ marginBottom: '12px' }}>
          <h3 style={{ 
            fontSize: '13px', 
            fontWeight: 'bold', 
            marginBottom: '8px',
            color: '#333',
          }}>{t('Customer Information')}</h3>
          <div style={{
            backgroundColor: '#f9f9f9',
            border: '1px solid #ccc',
            borderRadius: '6px',
            padding: '8px 12px'
          }}>
            <p style={{ fontSize: '11px', margin: '3px 0', color: '#333' }}>
              <strong>{t('name')}:</strong> {paymentData?.firstname} {paymentData?.lastname || ''}
            </p>
            <p style={{ fontSize: '11px', margin: '3px 0', color: '#333' }}>
              <strong>{t('address')}:</strong> {paymentData?.address || t('na')}
            </p>
            <p style={{ fontSize: '11px', margin: '3px 0', color: '#333' }}>
              <strong>{t('phone')}:</strong> {paymentData?.phone || t('na')}
            </p>
          </div>
        </div>
        
        <hr style={{ 
          border: 'none', 
          height: '1px', 
          backgroundColor: '#ccc', 
          margin: '12px 0'
        }} />
        
        <div className="invoice-table" style={{ marginTop: '12px' }}>
          <div style={{ 
            width: '100%', 
            fontSize: '11px',
            border: '1px solid #ccc',
            borderRadius: '6px',
            overflow: 'hidden'
          }}>
            {/* Header Row */}
            <div style={{
              background: 'rgba(200, 200, 200, 0.3)', 
              padding: '4px 8px',
              borderBottom: '1px solid #495057',
              fontSize: 11,
              fontWeight: 'bold',
              color: '#333',
              borderRadius: '4px 4px 0 0',
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '5%', textAlign: 'center' }}>#</div>
                <div style={{ width: '45%', paddingLeft: '4px' }}>{t('description')}</div>
                <div style={{ width: '10%', textAlign: 'center' }}>{t('quantity')}</div>
                <div style={{ width: '10%', textAlign: 'center' }}>{t('unit')}</div>
                <div style={{ width: '15%', textAlign: 'right' }}>{t('unitPrice')}</div>
                <div style={{ width: '15%', textAlign: 'right' }}>{t('total')}</div>
              </div>
            </div>

            {/* Table Body as Card Rows */}
            <div>
              {/* Render all class items */}
              {classes && classes.length > 0 ? (
                classes.map((cls, index) => (
                  <div 
                    key={`class-${index}`} 
                    style={{ 
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9',
                      padding: '4px 8px',
                      borderBottom: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      minHeight: '28px'
                    }}
                  >
                    <div style={{ width: '5%', textAlign: 'center', color: '#333', fontWeight: 'bold', fontSize: '11px' }}>{index + 1}</div>
                    <div style={{ width: '45%', paddingLeft: '4px', color: '#333' }}>
                      <div style={{ fontWeight: '500', fontSize: '11px' }}>
                        {cls.class_code} {cls.total_hours ? `(${(cls.total_hours / 60).toFixed(1)}h)` : ''}
                      </div>
                      {classes.length > 1 && (
                        <div style={{ fontSize: '9px', color: '#495057' }}>
                          (Class {index + 1} of {classes.length})
                        </div>
                      )}
                    </div>
                    <div style={{ width: '10%', textAlign: 'center', color: '#333', fontSize: '11px' }}>1</div>
                    <div style={{ width: '10%', textAlign: 'center', color: '#333', fontSize: '11px' }}>Course</div>
                    <div style={{ width: '15%', textAlign: 'right', color: '#333', fontSize: '11px' }}>฿{formatNumber(cls.price, i18n.language)}</div>
                    <div style={{ width: '15%', textAlign: 'right', color: '#333', fontWeight: 'bold', fontSize: '11px' }}>฿{formatNumber(cls.price, i18n.language)}</div>
                  </div>
                ))
              ) : (
                // Fallback for missing classes
                <div style={{ 
                  backgroundColor: '#ffffff',
                  padding: '4px 8px',
                  borderBottom: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  minHeight: '28px'
                }}>
                  <div style={{ width: '5%', textAlign: 'center', color: '#333', fontWeight: 'bold', fontSize: '11px' }}>1</div>
                  <div style={{ width: '45%', paddingLeft: '4px', color: '#333', fontWeight: '500', fontSize: '11px' }}>
                    Course Registration
                  </div>
                  <div style={{ width: '10%', textAlign: 'center', color: '#333', fontSize: '11px' }}>1</div>
                  <div style={{ width: '10%', textAlign: 'center', color: '#333', fontSize: '11px' }}>Course</div>
                  <div style={{ width: '15%', textAlign: 'right', color: '#333', fontSize: '11px' }}>
                    ฿{formatNumber(grandTotal, i18n.language)}
                  </div>
                  <div style={{ width: '15%', textAlign: 'right', color: '#333', fontWeight: 'bold', fontSize: '11px' }}>
                    ฿{formatNumber(grandTotal, i18n.language)}
                  </div>
                </div>
              )}
             
            </div>
          </div>
        </div>

        {/* Summary Information - Compact */}
        <div className="invoice-summary" style={{ 
          fontSize: 11,
          border: '1px solid #6c757d',
          padding: 8,
          background: 'linear-gradient(135deg, #f9f9f9 0%, #f0f0f0 100%)',
          borderRadius: 6,
          width: 280,
          marginLeft: 'auto',
          marginTop: '12px',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '3px 0', color: '#333' }}>
            <span>{t('subtotal')}:</span>
            <span>฿{formatNumber(totalBeforeDiscount, i18n.language)}</span>
          </div>
          
          {discountAmount > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '3px 0' }}>
              <span style={{ color: '#333' }}>{t('discount')}:</span>
              <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>-฿{formatNumber(discountAmount, i18n.language)}</span>
            </div>
          )}
          
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '3px 0', color: '#333' }}>
            <span>{t('Total After Discount')}:</span>
            <span>฿{formatNumber(totalAfterDiscount, i18n.language)}</span>
          </div>
          
          {vatAmount > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '3px 0', color: '#333' }}>
              <span>{t('vat', { percentage: 7 })}:</span>
              <span>฿{formatNumber(vatAmount, i18n.language)}</span>
            </div>
          )}
          
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            margin: '6px 0 4px 0',
            fontWeight: 'bold',
            fontSize: '12px',
            borderTop: '1px solid #6c757d',
            paddingTop: '4px',
            color: '#333'
          }}>
            <span>{t('grandTotal')}:</span>
            <span>฿{formatNumber(grandTotal, i18n.language)}</span>
          </div>
          
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            margin: '4px -8px 0 -8px',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '12px',
            backgroundColor: '#6c757d',
            padding: '6px 8px',
            borderRadius: '4px',
            textShadow: '1px 1px 2px rgba(0,0,0,0.2)'
          }}>
            <span>{t('Paid Amount')}:</span>
            <span>฿{formatNumber(payAmount, i18n.language)}</span>
          </div>
          
          {/* Only show remaining balance if needed */}
          {remainingBalance > 0 && (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              margin: '4px 0 0 0',
              color: '#d32f2f',
              fontWeight: 'bold',
              fontSize: '11px',
              backgroundColor: '#ffebee',
              padding: '4px 6px',
              borderRadius: '4px',
              border: '1px solid #ffcdd2'
            }}>
              <span>{t('Remaining Balance')}:</span>
              <span>(฿{formatNumber(remainingBalance, i18n.language)})</span>
            </div>
          )}
        </div>

        {/* Payment & Transaction Information - Compact */}
        <div className="payment-info" style={{ 
          marginTop: '12px',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <div style={{ 
            fontSize: '10px',
            textAlign: 'center',
            maxWidth: '400px',
            backgroundColor: '#f9f9f9',
            border: '1px solid #ccc',
            borderRadius: '6px',
            padding: '8px 12px'
          }}>
            <div style={{ 
              fontWeight: 'bold', 
              marginBottom: '6px', 
              color: '#333', 
              fontSize: '11px',
              borderBottom: '1px solid #ccc',
              paddingBottom: '3px'
            }}>
              {t('Payment & Transaction Information')}
            </div>
            
            <div style={{ lineHeight: '1.4', color: '#333' }}>
              <div><strong>{t('Method')}:</strong> {transformPaymentMethod(paymentData?.payment_method)}</div>
              
              {paymentData?.memo && (
                <div style={{ margin: '2px 0' }}>
                  <strong>{t('Memo')}:</strong> {paymentData.memo}
                </div>
              )}
              
              <div style={{ margin: '2px 0' }}>
                <strong>{t('Course')}:</strong> {courseCodes}
              </div>
              
              <div style={{ margin: '2px 0' }}>
                <strong>{t('Hours')}:</strong> {(totalHours / 60).toFixed(1)} {t('hrs')}
              </div>
              
              <div style={{ margin: '2px 0', color: 'green', fontWeight: 'bold' }}>
                <strong>{t('Payment Status')}:</strong> {t('Confirmed')}
              </div>
            </div>
          </div>
        </div>

        {/* QR Code, Signature, and Print Info Footer - Compact */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-end',
          marginTop: '16px',
          marginBottom: '12px',
          padding: '12px 0',
          borderTop: '1px solid #ccc'
        }}>
          {/* QR Code Section */}
          <div style={{ 
            width: '25%', 
            textAlign: 'center'
          }}>
            <QRCodeCanvas
              value={qrCodeData}
              size={50}
            />
            <div style={{ 
              fontSize: '9px', 
              marginTop: '4px', 
              color: '#495057',
              fontFamily: 'monospace',
              wordBreak: 'break-all',
              fontWeight: 'bold'
            }}>
              RECEIPT
            </div>
          </div>
          
          {/* Signature Section */}
          <div style={{ 
            width: '50%', 
            textAlign: 'center',
            padding: '0 16px'
          }}>
            <div>
              <div style={{ 
                fontSize: '11px', 
                fontWeight: 'bold', 
                marginBottom: '60px',
                color: '#333'
              }}>
                Authorized by
              </div>
              <div style={{ 
                borderTop: '1px solid #6c757d', 
                width: '240px', 
                margin: '0 auto',
                paddingTop: '6px',
                fontSize: '11px',
                color: '#333'
              }}>
                <div style={{ color: '#495057' }}>
                  Authorized Staff
                </div>
              </div>
            </div>
          </div>
          
          {/* Print Info Section */}
          <div style={{ 
            width: '25%', 
            textAlign: 'right', 
            fontSize: '10px', 
            color: '#495057'
          }}>
            <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>
              Printed On:
            </div>
            <div style={{ marginBottom: '1px' }}>
              {moment().format('DD MMM YYYY')}
            </div>
            <div>
              {moment().format('HH:mm:ss')}
            </div>
          </div>
        </div>
        
        {/* Note - Compact */}
        <div className="invoice-note" style={{ 
          textAlign: 'center', 
          marginTop: '8px',
          marginBottom: '12px'
        }}>
          <p style={{ fontSize: '9px', color: '#495057', marginBottom: '4px' }}>
            {t('Note: We appreciate your business. Please note that all transactions are final, and refunds cannot be processed.')}
          </p>
          {classes.length > 1 && (
            <p style={{ fontSize: '9px', color: '#495057', marginTop: '2px' }}>
              This receipt covers payment for {classes.length} classes in a single transaction.
            </p>
          )}
        </div>
        
        {/* Print Button - Compact */}
        <div className="invoice-actions" 
            style={{ 
              display: 'flex', 
              justifyContent: 'center',
              marginTop: '12px',
              '@media print': {
                display: 'none'
              }
            }}>
          <button 
            onClick={handlePrint}
            style={{
              padding: '8px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: '1px solid #495057',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: 'bold',
              transition: 'all 0.3s ease',
              textShadow: '1px 1px 2px rgba(0,0,0,0.2)'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#495057';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#6c757d';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            {t('printReceipt')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentReceiptModal;